import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { LoginComponent } from './components/login/login.component';
import { RedefinirSenhaComponent } from './components/redefinir-senha/redefinir-senha.component';
import { ChangePasswordComponent } from './components/change-password.component';
import { AuthSsoComponent } from './components/auth-sso.component';
import { EsqueciMinhaSenhaComponent } from './components/esqueci-minha-senha/esqueci-minha-senha.component';
import { AppRoutes } from '../../shared/constants/routes/routes.constant';
import { PoliticaPrivacidadeComponent } from './components/politica-privacidade/politica-privacidade.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: AppRoutes.LOGIN,
    pathMatch: 'full',
  },
  {
    path: AppRoutes.LOGIN,
    component: LoginComponent,
  },
  {
    path: AppRoutes.LOGIN + '/:email_confirmation_token',
    component: LoginComponent,
  },
  {
    path: AppRoutes.LOGOUT,
    redirectTo: AppRoutes.LOGIN,
    pathMatch: 'full',
  },
  {
    path: AppRoutes.FORGOT_PASSWORD,
    component: EsqueciMinhaSenhaComponent,
  },
  {
    path: AppRoutes.RESET_PASSWORD,
    component: RedefinirSenhaComponent,
  },
  {
    path: AppRoutes.CHANGE_PASSWORD,
    component: ChangePasswordComponent,
  },
  {
    path: AppRoutes.PRIVACY_POLICY,
    component: PoliticaPrivacidadeComponent,
  },
  {
    path: AppRoutes.AUTH_SSO,
    component: AuthSsoComponent,
  },
  {
    path: AppRoutes.ONBOARDING,
    loadChildren: () =>
      import('../../onboarding/onboarding.module').then(
        (module) => module.OnboardingModule
      ),
  },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
